/* eslint-disable react-hooks/exhaustive-deps, no-empty-function */
import { useEffect, useRef, useState } from 'react';
import fallbackIcon from './icons/placeholder.svg';

type imageCollectionType = Record<string, string>;

(window as any).IMAGES = {};

const appImages = (window as any).IMAGES;

const preloadImage = (path: string, checkLoadedImage: () => void) => {
  const image = new Image();
  appImages[path] = image;
  image.onerror = checkLoadedImage;
  image.onload = checkLoadedImage;
  image.src = path;
};

const checkImagePath = (path: string, checkLoadedImage: () => void) => {
  if (appImages[path]) {
    checkLoadedImage();
  } else {
    preloadImage(path, checkLoadedImage);
  }
};

preloadImage(fallbackIcon, () => {});

const useIcons = (images: imageCollectionType = {}, condition: boolean) => {
  const [loaded, setLoaded] = useState(false);
  const count = useRef(0);

  useEffect(() => {
    let flag = true;

    const checkLoadedImage = () => {
      count.current += 1;
      if (count.current === Object.keys(images).length && flag) {
        setLoaded(true);
      }
    };

    if (!condition && flag) {
      count.current = 0;
      setLoaded(false);
      Object.values(images).forEach((path) =>
        checkImagePath(path, checkLoadedImage)
      );
    }

    return () => {
      flag = false;
    };
  }, [images]);

  return loaded;
};

export default useIcons;
